<template>
    <section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>
        <div class="view__description">
            <p class="view__description__text">
                {{see_standard_reports ? 'In the Select Item column, select the items you want to include in the report, then click Run Report.' : 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Pariatur dolorem cumque possimus nobis ut iure architecto, assumenda iste cupiditate libero sed debitis magni deleniti enim corporis veniam et aut. Et.' }}
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="reports.length && hasPermissions(['Report Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <button v-if="hasPermissions(['Report Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div  v-if="hasPermissions(['Report Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mx-auto justify-content-center">
                <div class="templates__grid__tabs shadow-sm  bg-white rounded" style="width:100%; max-width:100%; font-size: 14px;">
                    <div id="nav-tab" role="tablist" class="nav nav-tabs templates__grid__item d-flex">
                        <a class="templates__grid__tabs__item" :class="see_standard_reports ? 'active' :''" id="future-schedule-tab" data-toggle="tab" 
                        href="#standar-reports" role="tab" aria-controls="future-schedule" aria-selected="false" v-html="'STANDARD REPORTS'" 
                        style="padding-left: 0px; text-align:center; width: 50%; text-decoration: none;"
                        @click="changeView(true)"/>
                        <a class="templates__grid__tabs__item" :class="!see_standard_reports ? 'active' :''" id="schedule-actual-tab" data-toggle="tab" 
                        href="#custom-reports" role="tab" aria-controls="schedule-actual" aria-selected="true" v-html="'CUSTOM REPORTS'" 
                        style="padding-left: 0px; text-align:center; width: 50%; text-decoration: none;"
                        @click="changeView(false)"/>
                    </div>          
                </div>
            </div>
        </div>
        <div class="tab-content" v-show="hasPermissions(['Report Read'])">
            <div class="row mb-0" v-if="!see_standard_reports">
                <div class="py-lg-0 col-md-12">
                    <div class="card cardModuleM h-100">
                        <div class="card-content h-100 d-md-flex align-items-md-center">
                            <div class="row mb-0 no-gutters">
                                <div class="col-lg-2 collection listColection">
                                    <h6 class="random-title" v-html="title_page"/>
                                    <a 
                                        v-for="(item, i) in system_list" :key="i" 
                                        :class="`collection-item list-colection-item ${report_render === item.identify ? 'list-colection-item-selected' : ''}`"
                                        :style="`font-weight:bold; text-decoration:none;`"
                                        v-html="item.name"
                                        :href="`#${item.identify}`"
                                        @click="ReportRender(item.identify)"
                                    />
                                </div>
                                <div class="col-lg-10 horizontal-scroll-reports">
                                    <div class="row mb-0 no-gutters">
                                        <div class="col-lg-12" >
                                            <DinamicTable
                                                :headers="table_headers"
                                                :items="display_report"
                                                :search="search"
                                                :checkable="true"
                                                :selectable_columns="false"
                                                :link="'new-reports/'"
                                                :margin_left="'margin-left:10px'"
                                            />
                                        </div>
                                    </div>
                                </div>   
                            </div>    
                        </div>
                    </div>
                </div>
            </div>
            <StandardReports
            :search="search"
            v-else
            />
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'Choose report type'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            :reports="reports" 
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Report Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

        <HelperModal :helps="helps"/>
        
        <!-- <HistoryModal
            :histories="histories"
            :title="history_title"
        /> -->

    </section>

    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>

</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import StandardReports from '../StandardReports/StandardReports';
import HelperModal              from    '@/components/HelperModal'
// import HistoryModal         from    '@/components/HistoryModal'
import DinamicTable         from    '@/components/DinamicTable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

    name: "Reports",

    components: {
    Breadcrumb,
    WaitingModal,
    DeletionModal,
    FormModal,
    UpdateModal,
    // HistoryModal,
    DinamicTable,
    DeletionMassiveModal,
    UnauthorizedComponent,
    StandardReports,
    HelperModal
},

    data() {
        return {
            notyf,
            axios,
            user:               this.get_user(),
            title_page:         'Reports',
            rest_api:           `reports`,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            system_list:        Resources.system_list,
            add_btn:            'Create new report',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            reports:          [],
            array_options:      {},
            report_render:      'all',


            table_selection_test:   [],
            table_headers_test:     Resources.table_headers_test,
            single_select_test:     {},
            search_test:            '',
            histories:              [],
            history_title:          '',
            select_ids:             [],
            see_standard_reports:   true,
            helps:                  Resources.helps
        };
    },
    
    computed:
    {
        selected()
        {
            const bool = this.reports.filter(item => item.checked)
            return Boolean(bool.length)
        },

        display_report()
        {
            if(this.report_render === 'buildings')
            {
                return  this.reports.filter(
                            item => item.module_name === 'buildings' || 
                                    item.module_name === 'levels' || 
                                    item.module_name === 'areas' ||
                                    item.module_name === 'rooms' ||
                                    item.module_name === 'rooms' ||
                                    item.module_name === 'cost_centers' ||
                                    item.module_name === 'cost_center_departments' ||
                                    item.module_name === 'cost_center_personals' ||
                                    item.module_name === 'room_types'
                        )
            }
            else if(this.report_render === 'associates')
            {
                return  this.reports.filter(
                            item => item.module_name === 'associates' || 
                                    item.module_name === 'positions' || 
                                    item.module_name === 'contract_types'
                        )

            }
            else if(this.report_render === 'assignments')
            {
                return  this.reports.filter(
                            item => item.module_name === 'daily_assignments' || 
                                    item.module_name === 'shifts' || 
                                    item.module_name === 'tasks' ||
                                    item.module_name === 'projects' ||
                                    item.module_name === 'service_requests'
                        )

            }
            else if(this.report_render === 'budgeting')
            {
                return  this.reports.filter(item => item.module_name === 'staffing_scenarios')
            }
            else if(this.report_render === 'census')
            {
                return  this.reports.filter(
                            item => item.module_name === 'beds' || 
                                    item.module_name === 'log_productivities'
                        )
            }
            else if(this.report_render === 'daysoff')
            {
                return  this.reports.filter(
                            item => 
                                    item.module_name === 'rotation_templates'
                        )
            }
            else if(this.report_render === 'qc')
            {
                return  this.reports.filter(
                            item => item.module_name === 'template_inspections' || 
                                    item.module_name === 'instant_inspections' || 
                                    item.module_name === 'inspection_items' || 
                                    item.module_name === 'inspection_templates' || 
                                    item.module_name === 'surveys'
                        )
            }
            else if(this.report_render === 'options')
            {
                return  this.reports.filter(
                            item => item.module_name === 'step_codes' || 
                                    item.module_name === 'time_off' || 
                                    item.module_name === 'floor_types' ||
                                    item.module_name === 'vacant_beds_adjustment'
                        )
            }
            return this.reports
        }
    },

    methods: {
        changeView(see_standard_reports)
        {
            this.see_standard_reports = see_standard_reports
            let route = `/reports?see_standard_reports=${see_standard_reports}`;
            this.$router
            .replace({
                path: route,
            })
            .catch(() => {});
        },

        ReportRender(render)
        {
            this.report_render = render
        },
    
        unshift_object(new_object)
        {
            this.reports.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.reports.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.reports[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.reports[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.reports = data.reports
            this.array_options = {
                facility_id: data.facilities
            }
        },

        trashing(index)
        {
            this.reports.splice(index, 1)
        },

        async history(id, title)
        {
            if(title === undefined)
            {
                title = id.title
                id = id.id
            }
            const http_request = {
                id,
                history_request: true,
            }
            this.loader(true)
            const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)
            this.loader()
            if(response.status)
            {
                this.history_title = title
                this.histories = response.data.histories

                setTimeout(()=>{
                    window.$('#static-history').modal('show')
                }, 500)
            }
            else
            {
                this.error_handling(response)
            }
            
        },

        massive_modal_delete()
        {
            this.select_ids = this.reports.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                id:         this.select_ids,
                massive:    true,
            }

            let sendingMassive = await this.massive_deletion(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.reports.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.reports.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },
        
    },

    async mounted()
    {
        if(this.hasPermissions(['Report Read']) )
        {
            if(this.$route.query.see_standard_reports === 'true' || this.$route.query.see_standard_reports === 'false')
            {
                this.see_standard_reports = this.$route.query.see_standard_reports === 'true' ? true : false
            }
            await this.api_request()
            // this.ReportRender(this.system_list[0].identify)
        }
    },

}
</script>
